import type { FC } from "react";
import { renderToString } from "react-dom/server";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { Link } from "@viagogo/core/ui";
import { Content, FormatContent, useContent } from "src/shared/components/content";
import type { ContentId } from "src/shared/components/content";
import { useAppContext } from "src/shared/context/AppContext";
import { writeUrl } from "src/shared/utils/url-builder";
import {
  AboutUsContainer,
  AboutUsContainerWithVideo,
  StyledTextDiv,
  StyledVideo,
  TextWrapper,
  VideoWrapper,
} from "src/website-apps/responsive/stubhub-about-us/components/viagogo/styled-components";

interface CompanyDescriptionParagraphProps {
  readonly contentId: ContentId;
}

const CompanyDescriptionParagraph: FC<CompanyDescriptionParagraphProps> = ({ contentId }) => (
  <StyledTextDiv>
    <Content id={contentId} />
  </StyledTextDiv>
);

const Paragraph6: FC = () => {
  const appContext = useAppContext();
  const helpCentreText = useContent("cid$#2993817#");
  const termsConditionsText = useContent("cid$#2993816#");
  const hereText = useContent("cid$#2993815#");
  return (
    <StyledTextDiv>
      <FormatContent
        id="cid$#2993818#"
        params={[
          renderToString(<Link url={writeUrl("/help", null, appContext)}>{helpCentreText}</Link>),
          renderToString(<Link url={writeUrl("/legal?section=ua", null, appContext)}>{termsConditionsText}</Link>),
          renderToString(<Link url={writeUrl("/help", null, appContext)}>{hereText}</Link>),
        ]}
        raw
      />
    </StyledTextDiv>
  );
};

const Contact: FC = () => {
  const appContext = useAppContext();
  const contactEmail = useContent("cid$#3573140#") || "presse@viagogo.com";
  return appContext.geographyCode === "de" ? (
    <StyledTextDiv>
      <FormatContent
        id="cid$#3573139#"
        params={[
          renderToString(<Link url={writeUrl(`mailto:${contactEmail}`, null, appContext)}>{contactEmail}</Link>),
        ]}
        raw
      />
    </StyledTextDiv>
  ) : null;
};

export const DescriptionAndVideo: FC = () => {
  const appContext = useAppContext();
  const isUkCobrand = appContext.cobrandId === 1;
  const isPhone = !useMediaQuery(Breakpoint.Tablet);
  const videoUrl = isPhone
    ? "https://media.stubhubstatic.com/stubhub-v2-catalog/video/upload/c_scale,w_600/v1676644612/videos/viagogo_about_us.mp4"
    : "https://media.stubhubstatic.com/stubhub-v2-catalog/video/upload/c_scale,w_1400/v1676644612/videos/viagogo_about_us.mp4";

  return isUkCobrand ? (
    <>
      <VideoWrapper>
        <StyledVideo controls poster="https://img.vggcdn.net/videos/viagogo_about_us_poster_2.jpg">
          <source src={videoUrl} type="video/mp4" />
        </StyledVideo>
      </VideoWrapper>
      <AboutUsContainerWithVideo>
        <TextWrapper>
          <CompanyDescriptionParagraph contentId="cid$#3036409#" />
        </TextWrapper>
        <TextWrapper>
          <CompanyDescriptionParagraph contentId="cid$#3036412#" />
        </TextWrapper>
        <TextWrapper>
          <CompanyDescriptionParagraph contentId="cid$#2983774#" />
        </TextWrapper>
        <TextWrapper>
          <CompanyDescriptionParagraph contentId="cid$#2983775#" />
        </TextWrapper>
        <TextWrapper>
          <CompanyDescriptionParagraph contentId="cid$#2983776#" />
          <Paragraph6 />
          <Contact />
        </TextWrapper>
      </AboutUsContainerWithVideo>
    </>
  ) : (
    <AboutUsContainer>
      <TextWrapper>
        <CompanyDescriptionParagraph contentId="cid$#3036409#" />
      </TextWrapper>
      <TextWrapper>
        <CompanyDescriptionParagraph contentId="cid$#3036412#" />
      </TextWrapper>
      <TextWrapper>
        <CompanyDescriptionParagraph contentId="cid$#2983774#" />
      </TextWrapper>
      <TextWrapper>
        <CompanyDescriptionParagraph contentId="cid$#2983775#" />
      </TextWrapper>
      <TextWrapper>
        <CompanyDescriptionParagraph contentId="cid$#2983776#" />
        <Paragraph6 />
        <Contact />
      </TextWrapper>
    </AboutUsContainer>
  );
};
